<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6">
        <b-card>
          <div slot="header">
            <strong>닐슨 데이터 입력</strong> <small>테스트</small>
          </div>
          <b-form-group
            label="File input"
            label-for="fileInput"
            :label-cols="2"
            :horizontal="true">
              <b-form-file id="fileInput" :plain="true"></b-form-file>
          </b-form-group>
          <div slot="footer">
            <b-button type="submit" size="sm" variant="primary" v-on:click="submit()"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
            <b-button type="reset" size="sm" variant="danger"><i class="fa fa-ban"></i> Reset</b-button>
          </div>
        </b-card>
      </b-col>
      <b-col sm="6">
        <b-card>
          <div slot="header">
            <strong>DMC 데이터 입력</strong> <small>테스트</small>
          </div>
          <b-form-group
            label="File input"
            label-for="dmcFileInput"
            :label-cols="2"
            :horizontal="true">
              <b-form-file id="dmcFileInput" :plain="true"></b-form-file>
          </b-form-group>
          <div slot="footer">
            <b-button type="submit" size="sm" variant="primary" v-on:click="submitDMC()"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
            <b-button type="reset" size="sm" variant="danger"><i class="fa fa-ban"></i> Reset</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-card>
          <div slot="header">
            <strong>DMC 코드데이터 입력</strong> <small>(업종 / 광고주 / 대행사)</small>
          </div>
          <b-form-group
            label="File input"
            label-for="codeFileInput"
            :label-cols="2"
            :horizontal="true">
              <b-form-file id="codeFileInput" :plain="true"></b-form-file>
          </b-form-group>
          <div slot="footer">
            <b-button type="submit" size="sm" variant="primary" v-on:click="submitCodeData()"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
            <b-button type="reset" size="sm" variant="danger"><i class="fa fa-ban"></i> Reset</b-button>
          </div>
        </b-card>
      </b-col>
      <b-col sm="6">
        <b-card>
          <div slot="header">
            <strong>계수 데이터 입력(VA)</strong> <small></small>
          </div>
          <b-form-group
            label="File input"
            label-for="cffcntFileInput"
            :label-cols="2"
            :horizontal="true">
              <b-form-file id="cffcntFileInput" :plain="true"></b-form-file>
          </b-form-group>
          <div slot="footer">
            <b-button type="submit" size="sm" variant="primary" v-on:click="submitCffcntData('va')"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
            <b-button type="reset" size="sm" variant="danger"><i class="fa fa-ban"></i> Reset</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <b-card>
          <div slot="header">
            <strong>계수 데이터 입력(DA)</strong> <small></small>
          </div>
          <b-form-group
            label="File input"
            label-for="cffcntFileInput"
            :label-cols="2"
            :horizontal="true">
              <b-form-file id="cffcntFileInputDA" :plain="true"></b-form-file>
          </b-form-group>
          <div slot="footer">
            <b-button type="submit" size="sm" variant="primary" v-on:click="submitCffcntData('da')"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
            <b-button type="reset" size="sm" variant="danger"><i class="fa fa-ban"></i> Reset</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data(){
    return {

    }
  },
  created: function() {

  },
  mounted: function() {

  },
  methods: {
    submit(str){
      console.log(document.getElementById('fileInput').files[0]);

      var data = new FormData();
      data.append('foo', 'bar');
      data.append('file', document.getElementById('fileInput').files[0]);
      var config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };

      var param ="?access_token=" + sessionStorage.getItem("myToken");
      this.$http.post('/api/upload/single'+param, data, config)
      .then((result) => {
        console.log(result);
      })
    },
    submitDMC(str){
      console.log(document.getElementById('dmcFileInput').files[0]);

      var data = new FormData();
      data.append('foo', 'bar');
      data.append('file', document.getElementById('dmcFileInput').files[0]);
      var config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };

      var param ="?access_token=" + sessionStorage.getItem("myToken");
      this.$http.post('/api/upload/dmcdata'+param, data, config)
      .then((result) => {
        console.log(result);
      })
    },
    submitCodeData(str){
      console.log(document.getElementById('codeFileInput').files[0]);

      var data = new FormData();
      data.append('foo', 'bar');
      data.append('file', document.getElementById('codeFileInput').files[0]);
      var config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };

      var param ="?access_token=" + sessionStorage.getItem("myToken");
      this.$http.post('/api/upload/codedata'+param, data, config)
      .then((result) => {
        console.log(result);
      })
    },
    submitCffcntData(type){


      var param ="?access_token=" + sessionStorage.getItem("myToken");
      if(type == 'va'){
        console.log(document.getElementById('cffcntFileInput').files[0]);

        var data = new FormData();
        data.append('foo', 'bar');
        data.append('file', document.getElementById('cffcntFileInput').files[0]);
        var config = {
          onUploadProgress: function(progressEvent) {
            var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
          }
        };
        this.$http.post('/api/upload/cffcnt'+param, data, config)
        .then((result) => {
          console.log(result);
        })
      }else{
        console.log(document.getElementById('cffcntFileInputDA').files[0]);

        var data = new FormData();
        data.append('foo', 'bar');
        data.append('file', document.getElementById('cffcntFileInputDA').files[0]);
        var config = {
          onUploadProgress: function(progressEvent) {
            var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
          }
        };
        this.$http.post('/api/upload/cffcntda'+param, data, config)
        .then((result) => {
          console.log(result);
        })
      }

    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/management/nielsen/NielsenData.vue